import React, { useState } from 'react';
import './App.css';
import Header from "./Header";
import Nav from "./Nav";
import Results from "./Results.js";
import requests from "./requests";
import Footer from "./Footer";

function App() {

  const [selectedOption, setSelectedOption] = useState(requests.fetchTrending);

  return (
    <div className="app">

      {/* <h1>Hule Film ✈</h1> */}

      {/* Header */}
      <Header setSelectedOption={setSelectedOption} />

      {/* NavBar */}
      {/* pass modifier as a prop a state's set as a prop!! */}
      <Nav setSelectedOption={setSelectedOption} />

      {/* Cards */}
      <Results selectedOption={selectedOption} />


      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
